import styled from 'styled-components';
import { BouncingLetter } from '../letterEffect/BouncingLetter';

export const EasterEggs = () => {
    return (
        <Container>
            <TitleContainer>
                <Title>
                    <BouncingLetter letter={'E'} index={1} />
                    <BouncingLetter letter={'A'} index={2} />
                    <BouncingLetter letter={'S'} index={3} />
                    <BouncingLetter letter={'T'} index={4} />
                    <BouncingLetter letter={'E'} index={5} />
                    <BouncingLetter letter={'R'} index={6} />
                    <div style={{ width: 20 }} />
                    <BouncingLetter letter={'E'} index={7} />
                    <BouncingLetter letter={'G'} index={8} />
                    <BouncingLetter letter={'G'} index={9} />
                    <BouncingLetter letter={'S'} index={10} />
                </Title>
            </TitleContainer>
            <PrinciplesContainer />
        </Container>
    );
};

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
`;

const Title = styled.div`
    display: flex;
    flex-direction: row;
`;

const PrinciplesContainer = styled.div`
    width: 100%;
    flex: 1;
`;
